import api from "@/lib/api";

const SESSION_KEY = "dyd_usage_session_id";
const HEARTBEAT_MS = 30_000;
const MAX_QUEUE = 40;

let heartbeatTimer = null;
let currentPage = "dashboard";
let queue = [];
let flushInFlight = false;

function getSessionId() {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = `s-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

function pageFromPath(path) {
  const parts = String(path || "").split("/").filter(Boolean);
  if (parts[0] === "dashboard") return parts[1] || "dashboard";
  return parts[0] || "home";
}

function pushEvent(action, durationSec = 30) {
  if (typeof window === "undefined") return;
  queue.push({
    page: currentPage,
    session_id: getSessionId(),
    action,
    duration_sec: durationSec,
  });
  if (queue.length > MAX_QUEUE) queue = queue.slice(-MAX_QUEUE);
  scheduleFlush();
}

async function flush() {
  if (flushInFlight || queue.length === 0) return;
  flushInFlight = true;
  const batch = queue.splice(0, queue.length);
  try {
    // The backend accepts one event per call; we fire in parallel but capped.
    await Promise.all(batch.map((ev) => api.post("/usage/track", ev).catch(() => {})));
  } finally {
    flushInFlight = false;
  }
}

let flushTimer = null;
function scheduleFlush() {
  if (flushTimer) return;
  flushTimer = setTimeout(() => {
    flushTimer = null;
    flush();
  }, 1500);
}

/** Registrar cambio de página */
export function trackPage(path) {
  currentPage = pageFromPath(path);
  pushEvent("view", 5);
}

/** Iniciar heartbeat + listeners globales */
export function startUsageTracker() {
  if (heartbeatTimer || typeof window === "undefined") return;
  heartbeatTimer = setInterval(() => {
    if (document.visibilityState === "visible") {
      pushEvent("ping", 30);
    }
  }, HEARTBEAT_MS);

  window.addEventListener("beforeunload", () => {
    pushEvent("end", 5);
    // navigator.sendBeacon for reliability on unload
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/usage/track`;
      const token = localStorage.getItem("padel_token");
      if (token && queue.length && navigator.sendBeacon) {
        for (const ev of queue) {
          const blob = new Blob([JSON.stringify(ev)], { type: "application/json" });
          navigator.sendBeacon(url, blob);
        }
        queue = [];
      }
    } catch { /* noop */ }
  });
}

/** Detener heartbeat (para logout) */
export function stopUsageTracker() {
  if (heartbeatTimer) { clearInterval(heartbeatTimer); heartbeatTimer = null; }
  queue = [];
  sessionStorage.removeItem(SESSION_KEY);
}
